// Stricter than the server's email check (Strapi/yup), so anything accepted here is accepted
// there too; Cyrillic addresses such as ivan@пошта.укр pass both.
const EMAIL_PATTERN = /^[\p{L}\p{N}!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}\p{N}!#$%&'*+/=?^_`{|}~-]+)*@(?:[\p{L}\p{N}](?:[\p{L}\p{N}-]*[\p{L}\p{N}])?\.)+\p{L}{2,}$/u;

export const isValidEmail = (value) => EMAIL_PATTERN.test(String(value ?? '').trim());

// Email fields are optional, so an empty value is fine.
export const isUnfinishedEmail = (value) => {
  const trimmed = String(value ?? '').trim();
  return Boolean(trimmed) && !EMAIL_PATTERN.test(trimmed);
};
